import * as React from 'react';
import { Box, Container, IconButton, AppBar, Grid, Divider } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LogoutIcon from '@mui/icons-material/Logout';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from "react-router-dom";
import pictionLogo from "../assets/piction-logo.png";

export default function CustomAppBar(props) {
    const navigate = useNavigate();

    const handleBack = () => {
        if (props.onBack) {
            props.onBack();
        } else {
            navigate(-1);
        }
    };

    const handleLogout = () => {
        navigate("/logout");
    };

    return (
        <>
            <AppBar
                elevation={0}
                position="sticky"
                sx={{
                    bgcolor: 'white',
                    color: 'black',
                    top: 0,
                    zIndex: 1100,
                    height: "4rem",
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Container
                    maxWidth="xl"
                    sx={{
                        paddingTop: "0.5rem",
                        paddingBottom: "0.5rem",
                        zIndex: 9999,
                        position: "relative",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    {!props.main ? (
                        <Grid container alignItems="center">
                            <Grid item xs={4}>
                                {!props.noBack && (
                                    <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                                        <IconButton sx={{ color: '#000' }} onClick={handleBack}>
                                            <ArrowBackIcon />
                                        </IconButton>
                                    </Box>
                                )}
                            </Grid>

                            <Grid item xs={4}>
                                <Box sx={{ display: "flex", justifyContent: "center" }}>
                                    <img
                                        src={pictionLogo}
                                        alt="Logo of Piction Health"
                                        style={{ maxWidth: "7rem" }}
                                    />
                                </Box>
                            </Grid>

                            {props.portal && <Grid item xs={4}>
                                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Tooltip title="Logout" arrow>
                                        <Box>
                                            <IconButton
                                                sx={{
                                                    color: '#000',
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "0.25rem"
                                                }}
                                                onClick={handleLogout}
                                            >
                                                <LogoutIcon />
                                                <span style={{ fontSize: "0.85rem" }}>Logout</span>
                                            </IconButton>
                                        </Box>
                                    </Tooltip>
                                </Box>
                            </Grid>}
                        </Grid>
                    ) : (
                        <div style={{ paddingLeft: 40 }}></div>
                    )}
                </Container >

                <Divider
                    sx={{
                        borderColor: "piction.highlight",
                        borderBottomWidth: 3,
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                    }}
                />
            </AppBar >
        </>
    );
}
